import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { useStore } from "@/store/useStore";
import { Button } from "@/components/Button";
import { Logo } from "@/components/AppShell";
import { useToast } from "@/components/Toast";

export default function Signup() {
  const navigate = useNavigate();
  const signup = useStore((s) => s.signup);
  const toast = useToast((s) => s.push);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");

  const submit = async () => {
    try {
      await signup({ username, email, display_name: displayName || undefined, password });
      toast({ tone: "ok", title: "Account created", desc: "Backend session active." });
      navigate("/app");
    } catch (e: any) {
      toast({ tone: "error", title: "Signup failed", desc: e.message });
    }
  };

  return (
    <div className="min-h-screen bg-strain-field grid place-items-center px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Logo className="w-8 h-8" />
          <span className="text-lg font-semibold tracking-tight">idea<span className="text-[var(--color-primary)]">strains</span></span>
        </Link>

        <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-card">
          <h1 className="text-lg font-semibold mb-1">Create an account</h1>
          <p className="text-[13px] text-[var(--color-ink-muted)] mb-4">Create a real local account in SQLite.</p>
          <div className="space-y-3">
            <Field label="username" value={username} onChange={setUsername} placeholder="you" />
            <Field label="email" value={email} onChange={setEmail} placeholder="you@example.com" />
            <Field label="display name (optional)" value={displayName} onChange={setDisplayName} placeholder="" />
            <Field label="password" value={password} onChange={setPassword} type="password" placeholder="••••••••" />
            <Button className="w-full" onClick={submit}>
              Create account
            </Button>
          </div>
          <div className="mt-4 text-center text-[12px] text-[var(--color-ink-muted)]">
            Already have one? <Link to="/login" className="text-[var(--color-primary)] hover:underline">Log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, placeholder, type = "text", value, onChange }: { label: string; placeholder: string; type?: string; value: string; onChange: (v: string) => void }) {
  return (
    <div>
      <label className="text-[10px] font-mono uppercase tracking-wider text-[var(--color-ink-muted)]">{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1 w-full h-10 px-3 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-2)] text-sm text-[var(--color-ink)]" />
    </div>
  );
}
